import tw, { styled } from 'twin.macro'
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export const Wrapper = styled('div')`
  ${tw`rounded-lg max-w-3xl mx-auto my-6 p-6 bg-red-500 text-white`}

  a {
    ${tw`text-white underline hover:text-red-100`}
  }
`

export default class ErrorMessage extends Component {

    render() {
        const { message } = this.props

        if (message && message.length > 0) {
            return (
                <Wrapper>
                    <strong>Error!</strong> {this.renderMessage(message)}
                </Wrapper>
            );
        }

        return null;
    }

    renderMessage = message => {
        if (this.props.allowHTML) {
            return <span dangerouslySetInnerHTML={{__html: message}}></span>;
        } else {
            return message;
        }
    }

}

ErrorMessage.propTypes = {
    message: PropTypes.string,
    allowHTML: PropTypes.bool
}
